import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { GeneralService } from 'src/app/services/general/general.service';
declare var JitsiMeetExternalAPI: any;

@Component({
  selector: 'app-jitsi',
  templateUrl: './jitsi.component.html',
  styleUrls: ['./jitsi.component.scss'],
})
export class JitsiComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() domain: string = 'jitsi1.ii3.es';
  @Input() room: string = 'conference';
  @Output() onDismiss = new EventEmitter<void>();
  @Output() updateTimeClass = new EventEmitter<void>();
  @Output() onToggleChat = new EventEmitter<void>();
  options: any;
  api: any;

  private user: any;
  private userInfo: any;

  interval: any;

  constructor(private general: GeneralService) {
  }

  async ngOnInit() {
    await this.getUserInfo();
  }

  ngOnDestroy(): void {
    this.api.removeEventListener('readyToClose', ($event: any) => {
      this.dismissConference();
    });

    clearInterval(this.interval);
  }

  async ngAfterViewInit() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
    this.options = {
      roomName: this.room,
      width: '100%',
      height: '100%',
      configOverwrite: {
        prejoinPageEnabled: false,
        conferenceInfo: {
          // those labels will not be hidden in tandem with the toolbox.
          alwaysVisible: ['recording', 'local-recording', 'raised-hands-count'],
          // those labels will be auto-hidden in tandem with the toolbox buttons.
          autoHide: [
            // 'subject',
            'conference-timer',
            'participants-count',
            'e2ee',
            'transcribing',
            'video-quality',
            'insecure-room',
          ],
        },
      },
      interfaceConfigOverwrite: {
        TOOLBAR_BUTTONS: [
          'microphone',
          'camera',
          'closedcaptions',
          'desktop',
          'fullscreen',
          'fodeviceselection',
          'hangup',
          'profile',
          'etherpad',
          // 'sharedvideo',
          'settings',
          'raisehand',
          'videoquality',
          'filmstrip',
          'feedback',
          'stats',
          'tileview',
          'videobackgroundblur',
          'help',
          'mute-everyone',
          'chat',
          // 'security',
        ],
        buttonsWithNotifyClick: ['chat'],
      },
      parentNode: document.querySelector('#jitsi-iframe'),
      userInfo: {
        displayName: this.user.fullName,
      },
    };

    this.api = new JitsiMeetExternalAPI(this.domain, this.options);

    // Event handlers
    this.api.addEventListener('readyToClose', ($event: any) => {
      this.dismissConference();
    });
    this.api.addEventListener('chatUpdated', ($event: any) => {
      this.onToggleChat.emit($event.isOpen);
    });

    if (this.user.rol === 'teacher') {
      this.initDurationInterval();
    }
  }

  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
    console.log("this.userInfo", this.userInfo);
    console.log("this.user", this.user);
    
  }

  dismissConference() {
    this.api.dispose();
    this.onDismiss.emit();
  }

  initDurationInterval() {
    this.updateTimeClass.emit();
    this.interval = setInterval(() => {
      this.updateTimeClass.emit();
    }, 60 * 1000);
  }
}
